import classNames from "classnames";
import React from "react";
import "./styles.less";

export const Title = ({ title = "", desc = "", theme = "light" }) => {
  return (
    <div
      className={classNames("open-page-header", `open-page-header--${theme}`)}
    >
      <div className="open-page-header-title open-basic-title">{title}</div>
      {desc && (
        <div className="open-page-header-subtitle open-basic-title-desc">
          {desc}
        </div>
      )}
    </div>
  );
};
